import { Context } from '@nuxt/types';
import { translateChainDisplayInfo } from '~/data/chain_info';

export default async function(context: Context) {
  const { app } = context;

  translateChainDisplayInfo(app.i18n);
}
